export default __webpack_public_path__ + "static/media/Ford_Script_Blue.235cff9f.png";